import { motion } from "framer-motion";

const Btn = ({ active, onClick, testId, children, activeClass }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`whitespace-nowrap rounded-full px-3 py-2 font-mono text-[10px] uppercase tracking-[0.15em] transition-colors duration-300 sm:px-4 sm:text-[11px] sm:tracking-[0.2em] ${
      active ? activeClass : "text-zinc-400 hover:text-white"
    }`}
  >
    {children}
  </button>
);

const ConceptSwitcher = ({ concept, onSelect }) => (
  <div className="pointer-events-none fixed inset-x-0 bottom-5 z-50 flex justify-center px-4">
    <motion.div
      data-testid="concept-switcher-container"
      initial={{ y: 90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.7, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="pointer-events-auto flex items-center gap-1 rounded-full border border-white/10 bg-black/75 p-1.5 shadow-2xl backdrop-blur-xl"
    >
    <Btn
      active={concept === null}
      onClick={() => onSelect(null)}
      testId="open-presentation-intro-button"
      activeClass="bg-white/15 text-white"
    >
      Intro
    </Btn>
    <Btn
      active={concept === "a"}
      onClick={() => onSelect("a")}
      testId="switch-concept-a-button"
      activeClass="bg-[#F4B032] text-[#0F0E0C]"
    >
      Concept A
    </Btn>
    <Btn
      active={concept === "b"}
      onClick={() => onSelect("b")}
      testId="switch-concept-b-button"
      activeClass="bg-[#F7F6F2] text-[#1C1B1A]"
    >
      <span className="sm:hidden">B</span>
      <span className="hidden sm:inline">Concept B</span>
    </Btn>
    <Btn
      active={concept === "catalog"}
      onClick={() => onSelect("catalog")}
      testId="switch-catalog-button"
      activeClass="bg-[#F4B032] text-[#0F0E0C]"
    >
      <span className="sm:hidden">RFQ</span>
      <span className="hidden sm:inline">Catalog + RFQ</span>
    </Btn>
    <Btn
      active={concept === "admin"}
      onClick={() => onSelect("admin")}
      testId="switch-admin-button"
      activeClass="bg-[#F4B032] text-[#0F0E0C]"
    >
      Admin
    </Btn>
    <Btn
      active={concept === "proposal"}
      onClick={() => onSelect("proposal")}
      testId="switch-proposal-button"
      activeClass="bg-[#1C1B1A] text-[#F4B032]"
    >
      <span className="sm:hidden">Scope</span>
      <span className="hidden sm:inline">Proposal</span>
    </Btn>
    </motion.div>
  </div>
);

export default ConceptSwitcher;
